require("!!/drone/src/node_modules/script-loader/addScript.js")(require("!!/drone/src/node_modules/raw-loader/index.js!/drone/src/node_modules/uglify-loader/index.js!/drone/src/3rdparty/box2d.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./node_modules/uglify-loader!./3rdparty/box2d.js
// module id = 90
// module chunks = 0